import { Typography } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

export const Scoring = ({ isShowTotalPoints, isShowCategoryScoring, scoring }) => {
  const { t } = useTranslation();

  return (
    <Flex>
      {isShowTotalPoints && scoring?.totalPoints >= 0 ? (
        <TotalScoreText>
          {t('Current risk score')}: <span style={{ fontWeight: 700 }}>{scoring.totalPoints}</span>
        </TotalScoreText>
      ) : null}

      {isShowCategoryScoring && scoring?.categoryScoring ? (
        <TotalScoreText>
          {t('Risk category')}:{' '}
          <span style={{ fontWeight: 700 }}>{scoring.categoryScoring.name}</span>
        </TotalScoreText>
      ) : null}
    </Flex>
  );
};

const Flex = styled.div`
  display: flex;
  flex-direction: column;
`;

const TotalScoreText = styled(Typography.Text)`
  font-size: 16px;
`;
